export default __webpack_public_path__ + "static/media/template3.7827e540.jpg";